import { Card, CardActionArea, CardContent, CardMedia } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import TagGroup from '../../../tags/components/TagGroup';
import { setCurrentBlogDetail } from '../../slices/blogPageReducer';
import CardTitleLink from '../../../../components/UIComponents/CardTitleLink';
import { contentPath } from '../../../../utils/contentPath';
// import { setCurrentBlogDetail } from '../../store/reducers/blogPageReducer';
// import TagGroup from '../TagComponents/TagGroup';

const BlogCardLarge = (props: BlogCard) => {
  const {
    id,
    slug,
    title,
    description,
    tags,
    image_blog_page,
    isPresentational,
    tag_limit = 12,
  } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const path = contentPath('blog', id, slug, title);

  const handleClickBlogCard = async (e: React.MouseEvent<HTMLDivElement>) => {
    if (!isPresentational) {
      dispatch(setCurrentBlogDetail(props));
      navigate(path);
    }
  };

  return (
    <Card
      className="blog-card-large"
      key={title}
      sx={{ boxShadow: '3px 2px 8px 4px rgba(0, 0, 0, 0.2)' }}
      onClick={handleClickBlogCard}
    >
      <CardActionArea
        component="div"
        className="blog-card-action-area"
        disabled={isPresentational}
      >
        <CardMedia
          component="img"
          image={image_blog_page}
          className="blog-card-img"
        />
        <CardContent className="blog-card-content">
          <h5>
            <CardTitleLink to={path} disabled={isPresentational}>
              {title}
            </CardTitleLink>
          </h5>
          <p>{description}</p>
          <TagGroup
            tagList={tags}
            tagLimit={tag_limit}
            isPresentational={isPresentational}
          />
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default BlogCardLarge;
